import { __extends } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import { window } from '@wix/photography-client-lib';
import { utils } from '../utils/webUtils';
var RenderStatusIndicator = /** @class */ (function (_super) {
    __extends(RenderStatusIndicator, _super);
    function RenderStatusIndicator(props) {
        var _this = _super.call(this, props) || this;
        _this.handleHover = function (hovered) {
            _this.setState({ hovered: hovered });
        };
        _this.generateRandomColor = function () {
            var letters = '0123456789ABCDEF';
            var color = '#';
            for (var i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color + '60';
        };
        _this.createIndicator = function () {
            return (React.createElement("div", { onMouseEnter: function () { return _this.handleHover(true); }, onMouseLeave: function () { return _this.handleHover(false); }, class: "render-indicator-pg", style: {
                    position: 'absolute',
                    bottom: '15.5px',
                    left: '15.5px',
                    maxWidth: '70%',
                    maxHeight: '70%',
                    border: '1px solid #717171',
                    padding: '5px 10px 5px 5px',
                    fontSize: '16px',
                    zIndex: '2147483648',
                    cursor: 'default',
                    lineHeight: '20px',
                    backgroundColor: _this.props.renderedGallery ? 'chartreuse' : 'red',
                } },
                React.createElement("table", { style: { tableLayout: 'fixed' } },
                    React.createElement("tr", null,
                        React.createElement("td", null, " PG render Indicator")),
                    React.createElement("tr", null,
                        React.createElement("td", null, " prerenderMode:"),
                        React.createElement("td", null,
                            " ",
                            _this.props.isPrerenderMode ? 'On' : 'Off')),
                    React.createElement("tr", null,
                        React.createElement("td", null, " Number of renders: "),
                        React.createElement("td", null,
                            " ",
                            _this.props.renderCount)),
                    _this.state.hovered && (React.createElement("tr", null,
                        React.createElement("td", null, " Items:"),
                        React.createElement("td", null,
                            " ",
                            _this.props.items.length))),
                    _this.state.hovered && (React.createElement("tr", null,
                        React.createElement("td", null, " container: "),
                        React.createElement("td", null,
                            React.createElement("tr", null,
                                React.createElement("td", null, " width: "),
                                React.createElement("td", null,
                                    " ",
                                    Math.round(_this.props.container.width),
                                    " ")),
                            React.createElement("tr", null,
                                React.createElement("td", null, " height: "),
                                React.createElement("td", null,
                                    " ",
                                    Math.round(_this.props.container.height),
                                    " ")),
                            React.createElement("tr", null,
                                React.createElement("td", null, " scrollBase:"),
                                React.createElement("td", null,
                                    " ",
                                    Math.round(_this.props.container.scrollBase),
                                    " "))))),
                    _this.state.hovered && (React.createElement("tr", null,
                        React.createElement("td", null, " worker log:"),
                        React.createElement("td", null,
                            React.createElement("div", { style: {
                                    maxHeight: '400px',
                                    overflow: 'auto',
                                    background: '#fff',
                                } }, _this.props.workerLog.map(function (log) { return (React.createElement("tr", null,
                                React.createElement("div", { style: {
                                        wordWrap: 'break-word',
                                        maxWidth: '500px',
                                        minWidth: '100px',
                                        backgroundColor: _this.generateRandomColor(),
                                    } }, log))); }))))))));
        };
        _this.state = { hovered: false };
        return _this;
    }
    RenderStatusIndicator.prototype.shouldUseReactPortal = function () {
        return !utils.isSSR();
    };
    RenderStatusIndicator.prototype.render = function () {
        var indicator = this.createIndicator();
        return this.shouldUseReactPortal()
            ? ReactDOM.createPortal(indicator, window.document.body)
            : indicator;
    };
    return RenderStatusIndicator;
}(React.Component));
export default RenderStatusIndicator;
//# sourceMappingURL=RenderStatusIndicator.js.map